module.exports = __webpack_public_path__ + "static/media/instantPolicies.3ecdbb30.jpg";